export function isScriptExist(url: string | unknown): boolean {
  if (typeof url === 'string') {
    const scriptsArr = Array.from(document.getElementsByTagName('script'));
    let isExist = false;
    for (let i = 0, len = scriptsArr.length; i < len; i += 1) {
      isExist =
        scriptsArr[i].src.replace('http:', 'https:') ===
        url.replace('http:', 'https:');
      if (isExist) {
        break;
      }
    }
    return isExist;
  }
  return false;
}

export interface LoadScriptOptions {
  src?: string;
  id?: string;
  async?: boolean;
}

/**
 * 动态创建script
 *
 * @param {Object} options 参数
 * @param {string} options.id 唯一id 可选，不传则默认挂载到 head 或者 body
 * @param {string} options.src script src 必传
 * @return {promise} 如果创建成功返回创建的script dom 失败返回 false
 */
export const loadScript = (options: LoadScriptOptions) => {
  if (!options.src) return Promise.resolve(false);
  if (options.id) {
    const script = document.querySelector(`script#${options.id}`);
    // 如果有script直接返回
    if (script) return Promise.resolve(script);
  }

  return new Promise((resolve) => {
    const parentDom = document.head || document.getElementsByTagName('body')[0];
    const scriptDom = document.createElement('script');
    const attrs = {
      type: 'text/javascript',
      async: options.async !== false,
      // crossorigin: 'anonymous', // 解决火狐跨域问题
      ...options,
    };

    Object.entries(attrs).forEach(([key, value]) => {
      scriptDom.setAttribute(key, `${value}`);
    });

    scriptDom.onload = () => {
      resolve(scriptDom);
    };

    scriptDom.onerror = () => {
      resolve(false);
    };

    scriptDom.src = options.src!;
    parentDom.appendChild(scriptDom);
  });
};

/**
 * Whether is in mobile
 *
 * @export
 * @return {*}  {boolean}
 */
export function isMobile(): boolean {
  const ua = navigator.userAgent;
  const isAndroid = /(?:Android)/.test(ua);
  const isFireFox = /(?:Firefox)/.test(ua);
  const isTablet =
    /(?:iPad|PlayBook)/.test(ua) ||
    (isAndroid && !/(?:Mobile)/.test(ua)) ||
    (isFireFox && /(?:Tablet)/.test(ua));
  const isIPhone = /(?:iPhone)/.test(ua) && !isTablet;

  return isIPhone || isAndroid;
}
